import { Injectable, Inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IToken } from '../models/account/account-models';
import { SecuritySettingsModel } from '../models/security/security-settings.model';

@Injectable()
export class JwtAuthInterceptor implements HttpInterceptor {
    private baseUrl: string;
    constructor(@Inject('BASE_URL') baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    intercept(req: HttpRequest<any>,
        next: HttpHandler): Observable<HttpEvent<any>> {
        //only add header if it is an internal api request, may need to rethink if we change to seperate api website
        if (req.url[0] == '/' || req.url.startsWith(this.baseUrl)) {
            const clonedRequest = req.clone({
                headers: req.headers.set(
                    'Authorization',
                    `bearer ${this.getToken()}`)
            });
            //console.log("new headers", clonedRequest.headers.keys());
            return next.handle(clonedRequest);
        }
        else
            return next.handle(req.clone());
    }
    getToken(authorize?: boolean): string {
        let tokenData = localStorage.getItem(SecuritySettingsModel.access_token);
        if (tokenData !== null) {
            let tokenJson = JSON.parse(tokenData) as IToken;
            let token: any = tokenJson.token;
            return token;
        }
        else
            return '';
    }
}